import { Component, HostListener, Injector, OnInit } from '@angular/core';
import { BaseComponent } from '../../../base.component';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { AddressesService } from '../../../../Services/addresses/Addresses';
import { LayoutService } from '../../../../Services/layout/layout.service';
import { includes, startsWith } from 'lodash';
import { ActionApiService } from '../../../../Services/action-api/action-api.service';
import { filter } from 'rxjs/operators';
import { ConfigService } from 'src/app/Services/config.service';

const errorStages = ['kickout', 'error'];

@Component({
	selector: 'edit-address-page',
	templateUrl: './edit-address-page.component.html',
	styleUrls: ['./edit-address-page.component.scss'],
})
export class EditAddressPageComponent extends BaseComponent implements OnInit {
	isPreloader: boolean;

	constructor(
		injector: Injector,
		private route: ActivatedRoute,
		private router: Router,
		private addresses: AddressesService,
		private actionApiService: ActionApiService,
		private LayoutService: LayoutService,
		private configService: ConfigService
	) {
		super(injector);
	}

	ngOnInit() {
		this.isPreloader = !!this.route.snapshot.params.isLoader;
		this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe((event) => {
			this.isPreloader = !!this.route.snapshot.params.isLoader;
			if (!this.isPreloader) {
				this.onRouteChange(event);
			}
		});
		const body = document.getElementsByTagName('body')[0];
		body.style.backgroundColor = 'white';
		this.addresses.showEditAddressReplaySubject.next(false);
	}

	onRouteChange(event) {
		const layOutStage = this.LayoutService.staticLayout.getValue().data.metadata.page.stage;
		const fromStage = this.router.routerState.snapshot.url.replace('/', '');
		if (layOutStage && includes(errorStages, layOutStage.toLowerCase())) {
			event.preventDefault();
		} else if (fromStage && includes(errorStages, fromStage.toLowerCase())) {
			event.preventDefault();
		} else {
			this.observablesService.showAjaxLoader.next(true);

			if (layOutStage == 'preloader') {
				this.observablesService.showPreloader.next(false);
				// Store.dispatch(fetchInterviewStage('Owners')); //todo
			} else {
				let arr = window.location.href.split('/');
				let stage = arr[arr.length - 1];
				const ajaxInfo: any = startsWith(`${this.configService.getConfig().ENV}`, 'bolt')
					? { action: 'GoToStage', stage }
					: { action: stage };
				this.actionApiService.ajaxAction(ajaxInfo, 'page');
				this.observablesService.ShouldPageLoadEvent = 'none';
				//  this.gtmService.virtualPageView('');//todo
			}
		}
	}
}
